<button
  mat-flat-button
  class="game-button" routerLink="/{{ game().game_provider_id && game().game_provider_id !== 'gains' ? 'provider-' : '' }}games/{{
    game().url_slug
  }}"
  trackEvent="game_card_select"
  [pageArea]="analyticsPageArea()"
  [trackEventParams]="{ game_id: game().game_id, event_source: analyticsEventSource() ?? analyticsPageArea() }"
  type="button"
  (click)="click.emit()"
>
  @if (game().card_image_url) {
    <app-image-loader
      class="game-image"
      [src]="game().card_image_url"
      [alt]="game().name"
      [spinnerSize]="device.isMobile() ? 20 : 32"
    />
  } @else {
    <div class="fallback-content ac-flex-col ac-gap-xs">
      <div class="game-title ac-title-lg">{{ game().name }}</div>
      <div class="ac-title-sm">{{ game().game_provider_name }}</div>
      <div>{{ game().game_type_id }}</div>
    </div>
  }
  @if (isNew()) {
    <span class="new-tag" aria-label="New game">NEW</span>
  }
</button>
